const navigationItems = {
    home: {},
    companies: {},
    calendar: {},
    support: {},
    agreements: {},
    matrix: {}
};

export const getNavigationItems = user => navigationItems;
